import { jhsWorks } from './images/jhs/works';
import { lskWorks } from './images/lsk/works';
import { kbbWorks } from './images/kbb/works';
import { gheWorks } from './images/ghe/works';
// import { lheWorks } from './images/lhe/works';
import { ajmWorks } from './images/ajm/works';
// import { lsbWorks } from './images/lsb/works';
import { jnsWorks } from './images/jns/works';
import { jjhWorks } from './images/jjh/works';
import { jjWorks } from './images/jj/works';
// import { bejWorks } from './images/bej/works';

import {
  ajmProfile,
  gheProfile,
  jhsProfile,
  jjProfile,
  jjhProfile,
  jnsProfile,
  kbbProfile,
  // lheProfile,
  // lsbProfile,
  lskProfile,
  // bejProfile,
} from './images';

export const MAIN = [];

export const ARTISTS = [];

export const ARTIST_DETAILS = {
  jhs: {
    id: 'jhs',
    nameKor: '정혜선',
    nameEng: 'Jung Hye Seon',
    profile: {
      circle: '',
      representative: '',
      images: jhsProfile,
    },
    works: jhsWorks,
    bio: {
      birth: '1942.02.21',
      debut: '1961년 KBS 공채 1기 탤런트',
      awards: [
        '2010 MBC 연기대상 공로상',
        '2010 대중문화 예술상 국무총리 표창',
        '2009 MBC 연기대상 황금연기상',
        '1994 백상예술대상 최우수 연기상'
      ],
    },
  },
  lsk: {
    id: 'lsk',
    nameKor: '이수경',
    nameEng: 'Lee Su Kyung',
    profile: {
      circle: '',
      representative: '',
      images: lskProfile,
    },
    works: lskWorks,
    bio: {
      birth: '1982.03.13',
      debut: '2003년 CF \'화이트\'',
      awards: [
        '2010년 SBS 연기대상 드라마스페셜부문 여자 조연상',
        '2009년 SBS 연기대상 10대 스타상',
        '2009년 제4회 핫드레그 베스트 스타 어워드 스타상',
        '2007년 KBS 연기대상 여자 신인상',
        '2007년 KBS 연기대상 베스트커플상 (with 김지훈)'
      ],
    },
  },
  kbb: {
    id: 'kbb',
    nameKor: '김비비',
    nameEng: 'Kim Bibi',
    profile: {
      circle: '',
      representative: '',
      images: kbbProfile,
    },
    works: kbbWorks,
    bio: {
      birth: '1978.02.22',
      debut: '1998년 뮤지컬 \'찬파만파 장보고여\'',
      awards: [],
    },
  },
  ghe: {
    id: 'ghe',
    nameKor: '길하은',
    nameEng: 'Gil Ha Eun',
    profile: {
      circle: '',
      representative: '',
      images: gheProfile,
    },
    works: gheWorks,
    bio: {
      birth: '1993.07.05',
      debut: '2019년 뮤지컬 \'그리스\'',
      awards: [],
    },
  },
  // lhe: {
  //   id: 'lhe',
  //   nameKor: '이황의',
  //   nameEng: 'Lee Hwang Eui',
  //   profile: {
  //     circle: '',
  //     representative: '',
  //     images: lheProfile,
  //   },
  //   works: lheWorks,
  //   bio: {
  //     birth: '1967.12.09',
  //     debut: '1988년 연극 \'금관의 예수\'',
  //     awards: [
  //       '2018년 제8회 서울연극인대상 연기상'
  //     ],
  //   },
  // },
  ajm: {
    id: 'ajm',
    nameKor: '안재모',
    nameEng: 'Ahn Jae Mo',
    profile: {
      circle: '',
      representative: '',
      images: ajmProfile,
    },
    works: ajmWorks,
    bio: {
      birth: '1979.09.20',
      debut: '1996년 KBS 드라마 \'신세대 보고 - 어른들은 몰라요\'',
      awards: [
        '2003년 백상예술대상 인기상',
        '2002년 SBS 연기대상 대상',
        '2002년 SBS 연기대상 10대 스타상',
        '2001년 SBS 연기대상 단막극 부문 연기상',
        '2000년 제36회 백상예술대상 TV부문 남자 신인연기상'
      ],
    },
  },
  // lsb: {
  //   id: 'lsb',
  //   nameKor: '이상보',
  //   nameEng: 'Lee Sang Bo',
  //   profile: {
  //     circle: '',
  //     representative: '',
  //     images: lsbProfile,
  //   },
  //   works: lsbWorks,
  //   bio: {
  //     birth: '1981.10.21',
  //     debut: '2006년 KBS 드라마 \'무영인자최장수\'',
  //     awards: [],
  //   },
  // },
  jns: {
    id: 'jns',
    nameKor: '장남수',
    nameEng: 'Jang Nam Su',
    profile: {
      circle: '',
      representative: '',
      images: jnsProfile,
    },
    works: jnsWorks,
    bio: {
      birth: '1989.07.23',
      debut: '2020년 영화 \'해적2\'',
      awards: [],
    },
  },
  jjh: {
    id: 'jjh',
    nameKor: '장정한',
    nameEng: 'Jang Jung Han',
    profile: {
      circle: '',
      representative: '',
      images: jjhProfile,
    },
    works: jjhWorks,
    bio: {
      birth: '1993.11.08',
      debut: '2017년 싱글앨범 \'I See U\'',
      awards: [],
    },
  },
  jj: {
    id: 'jj',
    nameKor: '준재',
    nameEng: 'JUNJE',
    profile: {
      circle: '',
      representative: '',
      images: jjProfile,
    },
    works: jjWorks,
    bio: {
      birth: '1997.10.15',
      debut: '2023년 4월 싱글앨범 \'Love Tree\'',
      awards: [],
    },
  },
  // bej: {
  //   id: 'bej',
  //   nameKor: '배은지',
  //   nameEng: 'Bae Eun Ji',
  //   profile: {
  //     circle: '',
  //     representative: '',
  //     images: bejProfile,
  //   },
  //   works: bejWorks,
  //   bio: {
  //     birth: '1998.08.21',
  //     debut: '2022년 한빛단 한복모델 선발대회',
  //     awards: [ ' 2022년 한빛단 한복모델 선발대전 美' ],
  //   },
  // },
};
